<template>
  <div class="globalSettins_page">
    <div class="settings_list">
      <GlobalSettingsItem
        v-for="(setting,key) in settings"
        :key="key"
        class="setting-item"
        :setting="setting"
        :name="key"
        @update="init"
      />
    </div>
  </div>
</template>

<script>
import GlobalSettingsItem from './Item/Index.vue'
export default {
  name: 'Parameters',
  components: {
    GlobalSettingsItem
  },
  data () {
    return {
      settings: {}
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init(){
      this.$http.v1.getMonitoringSettings((response) => {
        this.settings = response.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .globalSettins_page{
    height: 100%;
    overflow-y: auto;
    padding: 0 5px 5px 0;
  }
  .settings_list{
    column-count: 2;
    column-gap: 10px;

    .setting-item{
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
      break-inside: avoid;
      vertical-align: top;
    }
  }

  @media (max-width: 991px) {
    .settings_list{
      column-count: 1;
    }
  }
</style>
